// extracted by mini-css-extract-plugin
export default {"section":"selectableSection__section__wnGnF","active":"selectableSection__active__UpE51"};